<template>
  <div
    v-if="showWarning"
    class="kd-image-quality-indicator"
    :style="{ backgroundColor: warningColor }"
  >
    <div class="kd-image-quality-indicator__popover">
      {{text}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dpi: Number,
  },
  data() {
    return {
      textBad: 'Die Auflösung des Bildes ist leider nicht ausreichend. Bitte verwenden Sie ein höher aufgelöstes Bild.',
      textOkay: 'Das Auflösung des Bildes ist nicht optimal. Ein besseres Druckergebis wird mit höher aufgelösten Bildern erzielt (300 DPI oder mehr).',
      dpiOkay: 250,
      dpiGreat: 300,
    };
  },
  computed: {
    text() {
      if (this.dpi >= this.dpiGreat) { return ''; }
      if (this.dpi < this.dpiOkay) { return this.textBad; }
      return this.textOkay;
    },
    showWarning() {
      return this.dpi < this.dpiGreat;
    },
    warningColor() {
      if (this.dpi >= this.dpiGreat) { return 'transparent'; }
      if (this.dpi < this.dpiOkay) { return 'red'; } // TODO: Pick nicer red tone
      return 'yellow'; // TODO: Pick nicer yellow tone
    },
  },
};
</script>

<style lang="scss">
.kd-image-quality-indicator__popover {
  display: none;
  // position: absolute;
  // needed to be visible when popover goes over the edge of the card,
  // because the card has overflow: hidden
  position: absolute;
  top: 0;
  right: 0;
  width: 140px;
  z-index: 1000;
  padding: 10px;
  background-color: white;
  border-radius: 4px;
  font-size: 11px;

  &:hover { display: block; }
}

.kd-image-quality-indicator__circle {

}

.kd-image-quality-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 10px;
  height: 10px;
  margin: 0 auto;
  background: #f45756;
  border-radius: 100%;
  animation: pulse 1s infinite;
  animation-duration: 2s;

  &:hover .kd-image-quality-indicator__popover {
    display: block;
    line-height: 1.4em;
  }

  .kd--print & { display: none; } // hide in print mode
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 87, 86, 0.5);
  }
  70% {
    box-shadow: 0 0 0 14px rgba(245, 87, 86, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 87, 86, 0);
  }
}

</style>
